<template>
  <div class="smartTV">
    <div class="the-banner"></div>
    <div class="bgbox-white module1-conts">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <p class="module1-title"><span>智享系列（3.0品牌设计风格）</span></p>
        <p class="module1-msg"><span>适用于【高级酒店】【高级月子中心】【高级会所】等对自己品牌文化输出、设计观感有高要求、高标准，同时要求服务模块功能齐全，能满足用户多元化、多需求的场景</span></p>
        <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:24}" :lg="{span:8}">
          <div class="module1-item wow slideInLeft">
            <img :src="require('@/assets/images/smartTV-module1-1.jpg')" />
          </div>
        </el-col>
        <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:8}">
          <div class="module1-item wow slideInUp">
            <img :src="require('@/assets/images/smartTV-module1-2.jpg')" />
          </div>
        </el-col>
        <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:8}">
          <div class="module1-item wow slideInRight">
            <img :src="require('@/assets/images/smartTV-module1-3.jpg')" />
          </div>
        </el-col>
      </el-col>
    </div>
    <div class="bgbox-white module2-conts">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <p class="module-title"><span>智享系列皮肤UI简介</span></p>
        <p class="module2-msg"><span>神行者皮肤商城智享系列，将打造5个风格不一样的设计版本，每个设计系列都包含5个版本的颜色，供不同颜色审美风格的用户挑选。</span></p>
        <div class="module2-view clearfix">
          <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:10,offset:2}">
            <div class="item">
              <p class="title">C系列<img :src="require('@/assets/images/smartTV-module2-1.png')" /></p>
              <p class="line">撞色系</p>
              <p class="line">与色彩不期而遇，大胆撞色设计</p>
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:10}">
            <div class="item">
              <p class="title">N系列<img :src="require('@/assets/images/smartTV-module2-2.png')" /></p>
              <p class="line">简约系</p>
              <p class="line">简约不简单，美观且优雅</p>
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:10,offset:2}">
            <div class="item">
              <p class="title">G系列<img :src="require('@/assets/images/smartTV-module2-3.png')" /></p>
              <p class="line">国风系</p>
              <p class="line">曲径通幽处，禅房花木深</p>
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:10}">
            <div class="item">
              <p class="title">B系列<img :src="require('@/assets/images/smartTV-module2-4.png')" /></p>
              <p class="line">品牌系</p>
              <p class="line">寻找差异化竞争，打造个性化品牌</p>
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:10,offset:2}">
            <div class="item">
              <p class="title">X系列</p>
              <p class="line">神秘系列，敬请期待</p>
            </div>
          </el-col>
        </div>
      </el-col>
    </div>
    <div class="bgbox-gray module3-conts">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <p class="module-title"><span>皮肤套装轻松一键替换</span></p>
        <div class="clearfix">
          <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:10,offset:2}">
            <div class="img-box">
              <img :src="require('@/assets/images/smartTV-module3-1.jpg')" />
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:10}">
            <div class="img-box">
              <img :src="require('@/assets/images/smartTV-module3-2.jpg')" />
            </div>
          </el-col>
        </div>
        <p>皮肤商城所有上架的皮肤套装，像挑衣服一样简单，全部都能一键替换</p>
      </el-col>
    </div>
    <div class="bgbox-white module4-conts">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <p class="module-title"><span>智享C系列（炫紫版）</span></p>
        <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:12}">
          <div class="img-box">
            <img :src="require('@/assets/images/smartTV-module4-1.jpg')" />
          </div>
        </el-col>
        <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:12}">
          <div class="img-box">
            <img :src="require('@/assets/images/smartTV-module4-2.jpg')" />
          </div>
        </el-col>
        <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:12}">
          <div class="img-box">
            <img :src="require('@/assets/images/smartTV-module4-3.jpg')" />
          </div>
        </el-col>
        <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:12}">
          <div class="img-box">
            <img :src="require('@/assets/images/smartTV-module4-4.jpg')" />
          </div>
        </el-col>
      </el-col>
    </div>
    <div class="bgbox-white module4-conts">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <p class="module-title"><span>智享N系列（湛蓝版）</span></p>
        <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:12}">
          <div class="img-box">
            <img :src="require('@/assets/images/smartTV-module4-5.jpg')" />
          </div>
        </el-col>
        <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:12}">
          <div class="img-box">
            <img :src="require('@/assets/images/smartTV-module4-6.jpg')" />
          </div>
        </el-col>
        <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:12}">
          <div class="img-box">
            <img :src="require('@/assets/images/smartTV-module4-7.jpg')" />
          </div>
        </el-col>
        <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:12}">
          <div class="img-box">
            <img :src="require('@/assets/images/smartTV-module4-8.jpg')" />
          </div>
        </el-col>
      </el-col>
    </div>
    <div class="bgbox-white module4-conts">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <p class="module-title"><span>智享G系列（雅棕版）</span></p>
        <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:12}">
          <div class="img-box">
            <img :src="require('@/assets/images/smartTV-module4-9.jpg')" />
          </div>
        </el-col>
        <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:12}">
          <div class="img-box">
            <img :src="require('@/assets/images/smartTV-module4-10.jpg')" />
          </div>
        </el-col>
        <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:12}">
          <div class="img-box">
            <img :src="require('@/assets/images/smartTV-module4-11.jpg')" />
          </div>
        </el-col>
        <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:12}">
          <div class="img-box">
            <img :src="require('@/assets/images/smartTV-module4-12.jpg')" />
          </div>
        </el-col>
      </el-col>
    </div>
    <div class="bgbox-white module5-conts">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <p class="module-title"><span>功能展示</span></p>
        <div class="view clearfix">
          <div class="view-title">
            自定义开机视频
          </div>
          <el-row class="flex-row" type="flex" justify="center">
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
              <div class="img-box">
                <img :src="require('@/assets/images/smartTV-module5-1.jpg')" />
              </div>
            </el-col>
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
              <div class="infos-box">
                <h4>自定义开机视频</h4>
                <p class="line1">系统自带开机视频模块，酒店可以根据需要上传自制作的视频，实现开机后自启动播放视频宣传。</p>
                <div class="tag-box">
                  <el-tag>自定义视频内容建议：</el-tag>
                </div>
                <p class="line2">01 消防知识宣传片</p>
                <p class="line1">配合消防部门播放公共场所消防知识宣传片，提高酒店消防过审通过率。</p>
                <p class="line2">02 安全知识+禁令</p>
                <p class="line1">配合公安部门播放公共场所黄、赌、毒禁令等安全知识。</p>
                <p class="line2">03 酒店活动运营</p>
                <p class="line1">配合酒店营销部门播放酒店宣传片，酒店最新活动介绍等视频，提高宣传效果。</p>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="view clearfix">
          <div class="view-title">
            “实名制”欢迎页
          </div>
          <el-row class="flex-row" type="flex" justify="center">
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
              <div class="img-box">
                <img :src="require('@/assets/images/smartTV-module5-2.jpg')" />
              </div>
            </el-col>
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
              <div class="infos-box">
                <h4>实名定制化功能</h4>
                <p class="line1">系统提供接口可与酒管系统（PMS）对接，呈现入住酒店客户姓名。</p>
                <div class="tag-box">
                  <el-tag>可定制化欢迎页：</el-tag>
                </div>
                <p class="line1">开机视频播放完，自动跳转到欢迎页，让客户有宾至如归的感觉。欢迎页可实现欢迎词，酒店名称，日期，时间等内容，支持中英文切换模式。欢迎页背景图片可自定义，根据酒店的风格部署不同的背景图片。</p>
                <div class="icons-box">
                  <div class="icon-item">
                    <img :src="require('@/assets/images/smartTV2-icon1.svg')" >
                    <span>欢迎词</span>
                  </div>
                  <div class="icon-item">
                    <img :src="require('@/assets/images/smartTV2-icon2.svg')" >
                    <span>酒店LOGO</span>
                  </div>
                  <div class="icon-item">
                    <img :src="require('@/assets/images/smartTV2-icon3.svg')" >
                    <span>日期+时间</span>
                  </div>
                  <div class="icon-item">
                    <img :src="require('@/assets/images/smartTV2-icon4.svg')" >
                    <span>背景图</span>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="view clearfix">
          <div class="view-title">
            主界面模块展示
          </div>
          <el-row class="flex-row" type="flex" justify="center">
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
              <div class="img-box">
                <img :src="require('@/assets/images/smartTV-module5-3.jpg')" />
              </div>
            </el-col>
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
              <div class="infos-box">
                <h4>酒店服务模块功能</h4>
                <p class="line1">①界面上面板块显示【酒店LOGO】【机顶盒wifi信息】【时间】【日期】【wifi】【天气】等等；</p>
                <p class="line1">②左边视频展示板块，可以自定义播放视频。可以播放酒店的宣传视频等资源；</p>
                <p class="line1">③右边图片展示区域，最多可以展示10张图片，滚动播放。可以展示酒店介绍、宣传、活动；</p>
                <p class="line1">④功能板块可以支持5个模块，每个模块可以展示多样化内容。</p>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="view clearfix">
          <div class="view-title">
            高清影视模块展示
          </div>
          <el-row class="flex-row" type="flex" justify="center">
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
              <div class="img-box">
                <img :src="require('@/assets/images/smartTV-module5-4.jpg')" />
              </div>
            </el-col>
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
              <div class="infos-box">
                <h4>酒店影视模块功能</h4>
                <p class="line1">①电视家、网络直播（直播电视节目、网络直播模块）；</p>
                <p class="line1">②云视听极光（第三方合作APP）；</p>
                <p class="line1">③私密投屏（支持三层架构的投屏一机一屏一码保障私密性）；</p>
                <p class="line1">④热门影视（热门电影、剧集、综艺、新闻、短视频、网剧等等）。</p>
                <p class="line2">全面支持网络点播，本地点播，海量影片任您选</p>
                <p class="line1">(可根据需求分类，支持在线付费节目的临时预定或点播。还有播放、暂停、快进/退、断点续播、字幕切换、音轨切换等）</p>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="view clearfix">
          <div class="view-title">
            私密投屏模块展示
          </div>
          <el-row class="flex-row" type="flex" justify="center">
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
              <div class="img-box">
                <img :src="require('@/assets/images/smartTV-module5-5.jpg')" />
              </div>
            </el-col>
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
              <div class="infos-box">
                <h4>三层私密投屏功能（一机一屏一码）</h4>
                <p class="line1">手机扫描屏幕上的二维码，即可开启私密投屏功能，每块屏幕，仅允许一台手机扫码投屏；</p>
                <p class="line1">如果更换投屏的手机，只需退出投屏界面，无需关机；</p>
                <p class="line1">屏幕关机，代表投屏结束，超过一定范围，投屏会自然中断，下次投屏需重新扫码；</p>
                <p class="line1">每次投屏的二维码都不同，确保不会出现恶意投屏。</p>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="view clearfix">
          <div class="view-title">
            周边推荐模块展示
          </div>
          <el-row class="flex-row" type="flex" justify="center">
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
              <div class="img-box">
                <img :src="require('@/assets/images/smartTV-module5-6.jpg')" />
              </div>
            </el-col>
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
              <div class="infos-box">
                <h4>周边推荐模块功能</h4>
                <p class="line1">①周边介绍（可将酒店附近1KM~500内的各种（景点、便利店、餐厅、甜点铺、电影院等）做推荐，方便酒店顾客就近解决需求）；</p>
                <p class="line1">②美食推荐（可以与美食店捆绑合作，联合宣传，互相刺激消费）；</p>
                <p class="line1">③推荐景点（结合周边可玩的景点，可以与旅游公司或者景点园区合作，互相导流）；</p>
                <p class="line1">④本地特产（让游客熟知本地特产的同时，不时提醒消费者增加购买的可能性）。</p>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="view clearfix">
          <div class="view-title">
            酒店商城模块展示
          </div>
          <el-row class="flex-row" type="flex" justify="center">
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
              <div class="img-box">
                <img :src="require('@/assets/images/smartTV-module5-7.jpg')" />
              </div>
            </el-col>
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
              <div class="infos-box">
                <h4>酒店商城购物功能</h4>
                <p class="line1">为酒店可销售的产品提供展示窗口，让酒店住客了解产品资讯的同时，增加额外的消费几率与次数；</p>
                <p class="line1">酒店可以通过商城产生的数据做运营，了解客户需求的同时，通过分析增加销售最大化的可能性</p>
                <div class="icons-box">
                  <div class="icon-item">
                    <img :src="require('@/assets/images/smartTV3-icon1.svg')" >
                    <span>商品展示</span>
                  </div>
                  <div class="icon-item">
                    <img :src="require('@/assets/images/smartTV3-icon2.svg')" >
                    <span>购买数据</span>
                  </div>
                  <div class="icon-item">
                    <img :src="require('@/assets/images/smartTV3-icon3.svg')" >
                    <span>运营方案</span>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="view clearfix">
          <div class="view-title">
            酒店服务模块功能
          </div>
          <el-row class="flex-row" type="flex" justify="center">
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
              <div class="img-box">
                <img :src="require('@/assets/images/smartTV-module5-8.jpg')" />
              </div>
            </el-col>
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
              <div class="infos-box">
                <h4>酒店服务模块功能</h4>
                <p class="line1">服务模块可以按酒店需求自定义设置，比如增加退房服务、提醒服务、洗衣服务等；</p>
                <p class="line1">酒店可以根据客户不断变化的需求，新增更贴切客户的服务模块设置。</p>
                <div class="tag-box">
                  <img :src="require('@/assets/images/smartTV-module5-8.1.png')" />
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="view clearfix">
          <div class="view-title">
            酒店自定义模块功能
          </div>
          <el-row class="flex-row" type="flex" justify="center">
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
              <div class="img-box">
                <img :src="require('@/assets/images/smartTV-module5-9.jpg')" />
              </div>
            </el-col>
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
              <div class="infos-box">
                <h4>自定义模块功能</h4>
                <p class="line1">底部的功能模块，都可自定义，系统最多支持6个功能板块，酒店可根据客人的需求在系统部署，如音乐、地图、新闻、旅游等APK。</p>
                <div class="icons-box">
                  <div class="icon-item">
                    <img :src="require('@/assets/images/smartTV-icon1.png')" >
                  </div>
                  <div class="icon-item">
                    <img :src="require('@/assets/images/smartTV-icon2.png')" >
                  </div>
                  <div class="icon-item">
                    <img :src="require('@/assets/images/smartTV-icon3.png')" >
                  </div>
                  <div class="icon-item">
                    <img :src="require('@/assets/images/smartTV-icon4.png')" >
                  </div>
                  <div class="icon-item">
                    <img :src="require('@/assets/images/smartTV-icon5.png')" >
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="view clearfix">
          <div class="view-title">
            强制插播功能
          </div>
          <el-row class="flex-row" type="flex" justify="center">
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
              <div class="img-box">
                <img :src="require('@/assets/images/smartTV-module5-10.jpg')" />
              </div>
            </el-col>
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
              <div class="img-box">
                <img :src="require('@/assets/images/smartTV-module5-11.jpg')" />
              </div>
            </el-col>
          </el-row>
          <div class="infos-box">
            <p class="line1">可以插播酒店广告字幕或紧急通知等。（强制插播过程中，终端不接收遥控器任何指令)</p>
            <p class="line1">插播通知类型可以为文字、图片、视频。</p>
          </div>
        </div>
      </el-col>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    };
  }
};
</script>
<style lang="scss" scoped>
.bgbox-white {
  padding: 50px 10px;
  overflow: hidden;
  background: #fff;
  box-sizing: border-box;
}
.bgbox-gray {
  padding: 50px 10px;
  overflow: hidden;
  background: #f7f7f7;
  box-sizing: border-box;
}
.the-banner {
  height: 600px;
  background-image: url("../../../assets/images/smartTV-banner1.jpg");
  background-repeat: no-repeat;
  background-position: center;
}
.clearfix{
  &::after{
    content: '';
    clear: both;
    display: block;
  }
}
.flex-col{
  display: flex;
  align-items: center;
}
.module-title{
  text-align: center;
  font-size: 24px;
  color: #1f1f1f;
  line-height: 1;
  padding-bottom: 20px;
  position: relative;
  margin-bottom: 20px;
  &::after{
    content: "";
    position: absolute;
    width: 70px;
    height: 4px;
    background: #1f1f1f;
    bottom: 0;
    left: 50%;
    margin-left: -35px;
  }
}

.module1-conts{
  .module1-title{
    text-align: center;
    padding-bottom: 20px;
    span{
      display: block;
      font-size: 30px;
      color: #1f1f1f;
    }
  }
  .module1-msg{
    font-size: 18px;
    color: #757575;
    margin: 0 auto 50px auto;
    width: 100%;
    max-width: 840px;
    span{
      display: inline-block;
      text-align: center;
    }
  }
  .module1-item{
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    img{
      display: block;
      width: 100%;
      max-width: 320px;
      margin: 0 auto;
      transition: all 0.3s ease;
      &:hover{
        transform: translate3d(0,-2px,0);
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
      }
    }
  }
}

.module2-conts{
  .module2-msg{
    font-size: 18px;
    color: #757575;
    margin: 0 auto 50px auto;
    width: 100%;
    max-width: 780px;
    span{
      display: inline-block;
      text-align: center;
    }
  }
  .module2-view{
    .item{
      width: 100%;
      max-width: 300px;
      padding: 10px;
      box-sizing: border-box;
      margin: 0 auto 20px;
      .title{
        font-size: 22px;
        color: #1f1f1f;
        margin-bottom: 10px;
        img{
          height: 24px;
          display: inline-block;
          vertical-align: sub;
          margin-left: 10px;
        }
      }
      .line{
        font-size: 18px;
        color: #757575;
        margin-bottom: 10px;
      }
    }
  }
}

.module3-conts{
  .img-box{
    width: 100%;
    max-width: 380px;
    margin: 0 auto;
    img{
      display: block;
      width: 100%;
    }
  }
  p{
    font-size: 24px;
    color: #1f1f1f;
    text-align: center;
    padding-top: 20px;
  }
}

.module4-conts{
  .img-box{
    width: 100%;
    max-width: 700px;
    margin: 0 auto;
    padding: 10px;
    box-sizing: border-box;
    img{
      width: 100%;
    }
  }
}

.module5-conts{
  .view{
    padding: 40px 0;
    .view-title{
      font-size: 20px;
      color: #1f1f1f;
      position: relative;
      padding-left: 20px;
      box-sizing: border-box;
      margin-bottom: 30px;
      &::after{
        content: '';
        position: absolute;
        left: 0;
        top: 8px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #0072d4;
      }
    }
    .img-box{
      width: 100%;
      padding-right: 20px;
      padding-bottom: 20px;
      box-sizing: border-box;
      img{
        display: block;
        width: 100%;
        max-width: 630px;
        margin: 0 auto;
      }
    }
    .infos-box{
      padding-left: 20px;
      box-sizing: border-box;
      h4{
        font-size: 18px;
        color: #1f1f1f;
        font-weight: bold;
        margin-bottom: 18px;
      }
      .line1{
        font-size: 16px;
        color: #757575;
        margin-bottom: 16px;
      }
      .line2{
        font-size: 16px;
        color: #1f1f1f;
        margin-bottom: 5px;
      }
      .tag-box{
        padding: 20px 0 20px 0;
        img{
          display: block;
          width: 100%;
          max-width: 373px;
        }
      }
      .icons-box{
        .icon-item{
          width: 80px;
          height: 70px;
          float: left;
          margin-bottom: 10px;
          img{
            display: block;
            width: 46px;
            height: 46px;
            margin: 0 auto;
            margin-bottom: 5px;
          }
          span{
            display: block;
            font-size: 14px;
            color: #0f62b7;
            text-align: center;
          }
        }
      }
    }
  }
}


// 移动端css
@media screen and (max-width: 767px) {
  .the-banner{
    height: 300px;
    background-image: url("../../../assets/images/smartTV-banner2.jpg");
  }
  .module5-conts{
    .view{
      .img-box{
        padding-right: 0 !important;
      }
      .infos-box{
        padding-left: 0 !important;
      }
    }
  }
}

// 991
@media screen and (max-width: 991px) {
  .flex-row{
    display: block;
  }
}
</style>